import { render, staticRenderFns } from "./SignedUpForSms.vue?vue&type=template&id=68380ad5&scoped=true"
import script from "./SignedUpForSms.vue?vue&type=script&lang=js"
export * from "./SignedUpForSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68380ad5",
  null
  
)

export default component.exports